import React from "react"
import "./benefitsPartner.scss"

const COMPARE = [
  { label: "City coverage", others: "50-100", pulpit: "450+" },
  { label: "Payment cycle", others: "Weekly / Monthly", pulpit: "Daily" },
  { label: "Registration fee", others: "₹500 - ₹2,000", pulpit: "Free" },
  { label: "Driver support", others: "Limited hours", pulpit: "24/7" },
]

const FEATURES = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    title: "Flexible Hours",
    desc: "Drive full-time or part-time. No minimum hours, no penalties. You're in control.",
    tag: "Your Schedule",
    accent: "orange",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
      </svg>
    ),
    title: "450+ Cities",
    desc: "India's widest cab network. More cities, more local and outstation trip opportunities.",
    tag: "Pan India",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
    title: "Free Registration",
    desc: "Zero joining fee. Sign up online, get verified, start earning - completely free.",
    tag: "No Cost",
    accent: "orange",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    title: "24/7 Support",
    desc: "Dedicated round-the-clock help for drivers and fleet owners. Always just a call away.",
    tag: "Always On",
  },
]

const BenefitsPartner = () => {
  return (
    <section className="benefits-partner">
      <div className="benefits-partner__container">
        <h2 className="benefits-partner__heading">
          Why Cab Drivers <span>Choose</span> Pulpit
        </h2>
        <p className="benefits-partner__subheading">
          Everything you need to build a successful cab driver career in India
        </p>

        <div className="benefits-partner__bento">
          {/* Left: Comparison Table */}
          <div className="benefits-partner__compare">
            <h3 className="benefits-partner__compare-title">
              Pulpit vs Other Platforms
            </h3>
            <div className="benefits-partner__table">
              <div className="benefits-partner__table-head">
                <span />
                <span>Others</span>
                <span>Pulpit</span>
              </div>
              {COMPARE.map((row, i) => (
                <div className="benefits-partner__table-row" key={i}>
                  <span className="benefits-partner__table-label">{row.label}</span>
                  <span className="benefits-partner__table-others">{row.others}</span>
                  <span className="benefits-partner__table-pulpit">{row.pulpit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Feature Cards */}
          <div className="benefits-partner__features">
            {FEATURES.map((f, i) => (
              <div className={`benefits-partner__feature${f.accent === "orange" ? " benefits-partner__feature--orange" : ""}`} key={i}>
                <div className="benefits-partner__feature-top">
                  <div className="benefits-partner__feature-icon">{f.icon}</div>
                  <span className="benefits-partner__feature-tag">{f.tag}</span>
                </div>
                <h4 className="benefits-partner__feature-title">{f.title}</h4>
                <p className="benefits-partner__feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BenefitsPartner
